export default "__VITE_ASSET__BWNk55zA__"